// extracted by mini-css-extract-plugin
export var currencyInput = "_ln-1";
export var currencySymbol = "_ln-0";